import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftNavOpened = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.5,
		y: 2.9,
		width: 13,
		height: 10.2,
		rx: 2.5,
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 3L5 13",
		stroke: "currentColor",
		strokeLinecap: "round"
	})]
});
export default SvgLeftNavOpened;
